import axios from "axios";

const API = process.env.REACT_APP_API_URL || "http://localhost:5000";
const axiosInstance = axios.create({ baseURL: API, withCredentials: true });

export const getStatutoryConfig = async () => {
  const res = await axiosInstance.get("/api/payroll/statutory");
  return res.data;
};

export const updateStatutoryConfig = async (data) => {
  const res = await axiosInstance.put("/api/payroll/statutory", data);
  return res.data;
};
